import { render, staticRenderFns } from "./applyPayItem.vue?vue&type=template&id=3565c8a2&"
import script from "./applyPayItem.vue?vue&type=script&lang=js&"
export * from "./applyPayItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports